export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const GET_USERS_RESULT = "GET_USERS_RESULT";
export const ADD_USER_RESULT = "ADD_USER_RESULT";
export const DELETE_USER_RESULT = "DELETE_USER_RESULT";

export const GET_CONFIG_RESULT = "GET_CONFIG_RESULT";
export const UPDATE_CONFIG_RESULT = "UPDATE_CONFIG_RESULT";

export const GET_PLACES_RESULT = "GET_PLACES_RESULT";
export const ADD_PLACE_RESULT = "ADD_PLACE_RESULT";
export const UPDATE_PLACE_RESULT = "UPDATE_PLACE_RESULT";
export const DELETE_PLACE_RESULT = "DELETE_PLACE_RESULT";
export const GET_PLACE_ANALYTICS_RESULT = "GET_PLACE_ANALYTICS_RESULT";

export const GET_TARGETS_RESULT = "GET_TARGETS_RESULT";
export const ADD_TARGET_RESULT = "ADD_TARGET_RESULT";
export const UPDATE_TARGET_RESULT = "UPDATE_TARGET_RESULT";
export const DELETE_TARGET_RESULT = "DELETE_TARGET_RESULT";
export const GET_TARGETS_ANALYTICS_RESULT = "GET_TARGETS_ANALYTICS_RESULT";

export const UPLOAD_FILES_RESULT = "UPLOAD_FILES_RESULT";
export const GET_FILES_RESULT = "GET_FILES_RESULT";
export const SEARCH_FILES_RESULT = "SEARCH_FILES_RESULT";
export const DELETE_FILES_RESULT = "DELETE_FILES_RESULT";

export const GET_CITIES_RESULT = "GET_CITIES_RESULT";
export const UPDATE_CITY_RESULT = "UPDATE_CITY_RESULT";

export const GET_CATEGORIES_RESULT = "GET_CATEGORIES_RESULT";


// WEBPACK FOOTER //
// ./src/types.js